module.exports = __webpack_public_path__ + "assets/1afcf01a3af62d5b07bb5448e22f1c67.png";